import React from 'react';
import { Link } from '@zola/zola-ui/src/components/Link';
import OtherThingsToReview from './OtherThingsToReview';
import './TipsModals.less';

function TipEnvelope() {
  return (
    <div className="etiquette-tip-modal">
      <div className="tip-content-container">
        <div className="modal-body">
          <h3>The Anatomy of a Wedding Envelope</h3>
          <div className="section">
            <p className="desc">
              We’ve broken down exactly what you should write on (or stick to) your wedding envelope
              and where, so you can craft your wedding envelopes with peace of mind.
            </p>
            <div className="border-box">
              <span className="box-returnaddress">Return address</span>
              <span className="box-postage">Postage</span>
              <span className="box-recipient">Recipient Address</span>
            </div>
          </div>
          <div className="section">
            <p className="head">Return Address:</p>
            <p className="desc">
              Typically located in the upper left corner, the return address indicates who is
              sending this piece of mail. Your guests are being invited by—and should be replying
              to—the host. No matter who the host is, be consistent with your labeling and use the
              same return address on the invitation envelope as what’s printed on the front of the
              RSVP card envelope. Multiple hosts? Pick the one that works for you.
            </p>
          </div>
          <div className="section">
            <p className="head">Recipient Address:</p>
            <p className="desc">
              Located in the center middle of the envelope, the recipient address indicates who is
              receiving this piece of mail. Use Zola’s free guest addressing to let folks know
              exactly who is receiving the invitation and whom you expect to respond. For tons of
              tips on addressing etiquette, check out{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/invitation-wording/how-to-address-wedding-invitations/"
                target="_blank"
              >
                our expert advice
              </Link>
              .
            </p>
          </div>
          <div className="section">
            <p className="head">Postage:</p>
            <p className="desc">
              The stamp(s) required to mail the envelope are placed in the upper right corner.
              Assemble one complete wedding envelope, take it to the post office, and have it
              weighed so you can calculate your total postage costs. Then stock up on adequate
              postage of your choosing to ensure your invites will successfully reach their
              destinations.
            </p>
            <p className="desc">
              Discover some great{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/wedding-invitations/wedding-invitation-postage/"
                target="_blank"
              >
                postage pointers
              </Link>{' '}
              on our blog, as well as more about{' '}
              <Link
                inline
                rel="noopener noreferrer"
                href="/expert-advice/invites-paper/wedding-invitations/wedding-invitations-guide-to-envelopes/"
                target="_blank"
              >
                the anatomy of a wedding envelope
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
      <OtherThingsToReview />
    </div>
  );
}

export default TipEnvelope;
